<template>
  <tr>
    <td colspan="3" class="text-left">
      <div class="confection-inputs">
        <div class="radio-inline d-flex align-items-center mb-4">
          <input
            type="radio"
            name="confection-personalization-type"
            id="confection-personalization-type-same"
            :value="false"
            @change="handlePersonalizationTypeChange"
            v-model="hasIndividualPersonalization"
          />
          <label for="confection-personalization-type-same">
            <slot name="label-shared"></slot>
            <span class="d-block text-small text-muted">np. Wesołych świąt</span>
          </label>
        </div>
        <basic-input
          v-if="!hasIndividualPersonalization"
          validationRule="required|max:50"
          name="confection-personalization-text"
          labelClass="mb-2"
          label="Treść nadruku"
          inputType="text"
          v-model="personalizationText"
        />
        <div class="radio-inline d-flex align-items-center ml-0 my-4">
          <input
            type="radio"
            name="confection-personalization-type"
            id="confection-personalization-type-different"
            :value="true"
            @change="handlePersonalizationTypeChange"
            v-model="hasIndividualPersonalization"
          />
          <label for="confection-personalization-type-different">
            <slot name="label-individual"></slot>
            <span class="d-block text-small text-muted">np. imię i nazwisko, nazwa działu</span>
          </label>
        </div>
        <custom-alert
          v-if="hasIndividualPersonalization"
          type="info"
          :withIcon="false"
          class="mb-4 text-left font-weight-normal"
        >
          Treść nadruku indywidualnego dodasz przy definiowaniu dostawy w kolejnych krokach.
        </custom-alert>
        <basic-textarea
          v-if="hasIndividualPersonalization"
          validationRule="required|max:200"
          name="confection-personalization-comment"
          labelClass="mb-2"
          label="Komentarz"
          v-model="personalizationComment"
          rows="2"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import BasicInput from '../Inputs/basicInput.vue';
import BasicTextarea from '../Inputs/basicTextarea.vue';
import CustomAlert from '../CustomAlert.vue';

export default {
  name: 'NDEConfectionPersonalizationForm',
  components: {
    BasicInput,
    BasicTextarea,
    CustomAlert,
  },
  computed: {
    ...mapFields('confection', [
      'hasIndividualPersonalization',
      'personalizationText',
      'personalizationComment',
    ]),
    ...mapFields('delivery', ['inputMode']),
  },
  methods: {
    handlePersonalizationTypeChange() {
      this.inputMode = null;
    },
  },
};
</script>
